import { HttpClient } from './apiModels';
import { cupAuthService } from '../../auth/cupAuthService';
import { adminAuthService } from '../../auth/adminAuthService';
import { env } from '../../../env';

export class FetchHttpClient implements HttpClient {
  async request<R>(requestConfig: {
    method: string;
    url: string;
    queryParams?: any;
    data?: any;
    copyFn?: (data: R) => R;
    headers?: any;
  }): Promise<R> {
    let url = `${env.apiBaseUrl}/${requestConfig.url}`;

    const { tenantKey, cupPassword } = cupAuthService().getCredentials();
    const { token } = await adminAuthService().getAdminCredentials();
    // Add query parameters to the URL if any
    if (requestConfig.queryParams) {
      const queryParams = new URLSearchParams(requestConfig.queryParams).toString();
      url += `?${queryParams}`;
    }

    const response = await fetch(url, {
      method: requestConfig.method,
      headers: requestConfig.headers
        ? requestConfig.headers
        : {
            'Content-Type': 'application/json',
            'x-tenant-key': tenantKey,
            'x-cup-pw': cupPassword,
            'x-admin-token': token,
          },
      body: requestConfig.data ? JSON.stringify(requestConfig.data) : undefined,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const text = await response.text();
    const result: R = text ? JSON.parse(text) : ({} as R);

    // Apply optional copy function if provided
    if (requestConfig.copyFn) {
      return requestConfig.copyFn(result);
    }

    return result;
  }
}
